const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(process.env.REACT_APP_API_BASE_URL || "");
export const TOKEN_STORAGE_KEY = process.env.REACT_APP_TOKEN_STORAGE_KEY || "token";
export const LOGIN_STORAGE_KEY = process.env.REACT_APP_LOGIN_STORAGE_KEY || "isLoggedIn";
export const SETTINGS_STORAGE_KEY = process.env.REACT_APP_SETTINGS_STORAGE_KEY || "ocean_connect_settings";
export const REMEMBER_ME_STORAGE_KEY = process.env.REACT_APP_REMEMBER_ME_STORAGE_KEY || "rememberMe";
export const APP_NAME = process.env.REACT_APP_APP_NAME || "Ocean Connect";
export const APP_PUBLIC_URL = process.env.REACT_APP_APP_PUBLIC_URL || "#";
export const APP_FOOTER_TEXT = process.env.REACT_APP_APP_FOOTER_TEXT || "Ocean Connect";
export const APP_LOGIN_LOGO_TEXT = (process.env.REACT_APP_LOGIN_LOGO_TEXT || "OceanConnect").replace(/\s+/g, "");
export const APP_HEADER_LOGO_TEXT = (process.env.REACT_APP_HEADER_LOGO_TEXT || "OceanConnect").replace(/\s+/g, "");
